import gmapsInit from '../../components/checkout/delivery/map'
import { createMapInfoModal } from '@/helpers/createMapInfoModal'
import { processBrowserNavigator } from '@/helpers/processBrowserNavigator'
import constants from '@/helpers/constants'
import { GoogleTagManagerService } from '@/services/AnalyticService'
import detectMobileDevices from '@/helpers/detectMobileDevices'

export default {
  state: {
    map: null,
    markers: [],
    userMarker: null,
    addressMarker: null,
    citiesZoom: {
      'киев': 10,
      'львов': 13,
      'одесса': 12,
      'харьков': 12,
      'днепр': 12,
      'винница': 13,
      'луцк': 13,
      'житомир': 13,
      'ужгород': 14,
      'запорожье': 12,
      'ивано-франковск': 14,
      'кропивни́цкий': 13,
      'николаев': 12,
      'полтава': 13,
      'ровно': 13,
      'сумы': 13,
      'тернополь': 13,
      'херсон': 12,
      'хмельницкий': 13,
      'черкассы': 13,
      'чернигов': 13,
      'черновцы': 13,
      'кривой рог': 13
    },
    autocomplete: null,
    infoModal: null,
    bounds: null,
    selectedSpot: null,
    markerClusters: null,
    preselectedSpot: null
  },
  mutations: {
    SET_MAP (state, map) {
      state.map = map
    },
    SET_MARKERS (state, markers) {
      state.markers = markers
    },
    SET_USER_MARKER (state, marker) {
      state.userMarker = marker
    },
    SET_ADDRESS_MARKER (state, marker) {
      state.addressMarker = marker
    },
    SET_AUTOCOMPLETE (state, autocomplete) {
      state.autocomplete = autocomplete
    },
    SET_INFO_MODAL (state, infoModal) {
      state.infoModal = infoModal
    },
    SET_BOUNDS (state, bounds) {
      state.bounds = bounds
    },
    SET_SELECTED_SPOT (state, spot) {
      state.selectedSpot = spot
    },
    SET_MARKER_CLUSTERS (state, markerClusters) {
      state.markerClusters = markerClusters
    },
    SET_PRESELECTED_SPOT (state, spot) {
      state.preselectedSpot = spot
    }
  },
  actions: {
    async SET_MAP_ACTION (
      { commit, dispatch, rootState, state, rootGetters },
      { spotsInfo, ourSpotsInfo, mailName, ourMailName, modal }
    ) {
      await gmapsInit()
      // const { latitude, longitude, name: cityName } = rootState.geoLocation.selectedUserLocation
      let position
      let zoom = 15

      if (constants.IS_CHECKOUT()) {
        const { deliveryInfo } = rootState.checkout.formData

        if (deliveryInfo && deliveryInfo.deliverySpot) {
          const { latitude, longitude } = deliveryInfo.deliverySpot

          position = new window.google.maps.LatLng({ lat: +latitude, lng: +longitude })
          zoom = 17
        } else if (
          !constants.IS_CHECKOUT_SUCCESS() && rootState.geoLocation.exactUserLocation.city_id
        ) {
          const { latitude, longitude } = rootState.geoLocation.exactUserLocation

          position = new window.google.maps.LatLng({ lat: +latitude, lng: +longitude })
        }
      }
      commit(
        'SET_MAP',
        new window.google.maps.Map(document.querySelector('.map-vue'), {
          zoom,
          center: position,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false
          // zoomControlOptions: {
          //   position: window.google.maps.ControlPosition.RIGHT_CENTER
          // }
        })
      )
      dispatch('CREATE_MARKERS', { spotsInfo, ourSpotsInfo, mailName, ourMailName, modal })
    },
    SET_MAP_POSITION_BY_GEO ({ commit, state, dispatch, rootState }, isFromFindMe) {
      const { exactUserLocation, selectedUserLocation } = rootState.geoLocation

      const position = new window.google.maps.LatLng({
        lat: +exactUserLocation.latitude,
        lng: +exactUserLocation.longitude
      })

      if (
        (isFromFindMe ||
          ((exactUserLocation.city_id === selectedUserLocation.city_id || constants.IS_CHECKOUT()) &&
            exactUserLocation.source === 'gps')) &&
        !constants.IS_CHECKOUT_SUCCESS()
      ) {
        if (state.userMarker) {
          state.userMarker.setPosition(position)
        } else {
          commit(
            'SET_USER_MARKER',
            new window.google.maps.Marker({
              position,
              map: state.map,
              icon: {
                url: `/img/svgo/map-pin-user-location.svg`,
                size: new window.google.maps.Size(50, 50),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(25, 25)
              }
            })
          )
        }
        const isCheckout = constants.IS_CHECKOUT()
        const isThankyouPage = constants.IS_CHECKOUT_SUCCESS()
        if (!isThankyouPage && (!isCheckout || (isCheckout && rootState.geoLocation.isCityFromGeoSelected))) {
          dispatch('FIND_NEAREST_SPOT', position)
        }
      }
    },
    CREATE_MARKERS (
      { commit, state, rootGetters, dispatch, rootState },
      { spotsInfo, ourSpotsInfo, mailName, ourMailName, modal }
    ) {
      if (state.markers.length) {
        state.markers.forEach(marker => {
          marker.setMap(null)
        })
        commit('SET_MARKERS', [])
        if (state.markerClusters) {
          state.markerClusters.clearMarkers()
        }
      }
      const hashTable = {}
      const coordinatesProcessing = (spot, ourSpot = false) => {
        // Обрадатывае координаты отдела
        const lat = spot.latitude
        const lng = spot.longitude

        if (!lat || !lng) return null
        // Подрезает координаты что бы они были одной длины
        const mainLat = lat.substring(0, 7)
        const mainLng = lng.substring(0, 7)

        const hashTableKey = mainLat + mainLng

        let addition = 0
        // Выявляет повторяющиеся коориданы
        if (!hashTable.hasOwnProperty(hashTableKey)) {
          hashTable[hashTableKey] = 0
          addition = 0
        } else if (hashTable.hasOwnProperty(hashTableKey)) {
          hashTable[hashTableKey]++
          addition = 45 * hashTable[hashTableKey]
        }
        // Если есть повторяющиеся координаты то к долготе добавляется число что бы маркеры не показывались в одной точке
        let spotLat = parseFloat(lat.substring(0, 9) + addition)
        let spotLng = parseFloat(lng.substring(0, 9))

        if (this.mailName === 'pickupInternational' || this.mailName === 'pickup' || this.mailName === 'ukrposhta' || ourSpot) {
          spotLat = parseFloat(spot.latitude)
          spotLng = parseFloat(spot.longitude)
        }
        return { latitude: spotLat, longitude: spotLng }
      }
      const markers = []

      const markerIcon = type => {
        if (rootState.user.userType === constants.USER_TYPE.MANAGER) {
          if (type === 'partner_store') return '/img/svgo/map/map-pin-dm-partner.svg'
          else if (type === 'franchisees_store') return '/img/svgo/map/map-pin-dm-franchisees.svg'
          else if (type === 'ofp_store') return '/img/svgo/map/map-pin-dm-ofp.svg'
        }

        if (mailName === 'pickupInternational' || mailName === 'pickup' || type === 'our_shop') return '/img/svgo/map/map-pin-dm.svg'
        else if (mailName === 'novaPoshtaWarehouse') return '/img/svgo/map/map-pin-np.svg'
        else if (mailName === 'ukrposhta') return '/img/svgo/map/map-pin-up.svg'
        else if (mailName === 'inpostParcel') return '/img/svgo/map/map-pin-inpost.svg'
        else if (mailName === 'pickupDPDInternational') return '/img/svgo/map/map-pin-dpd.svg'

        return '/img/svgo/map/map-pin-dm.svg'
      }
      commit('SET_INFO_MODAL', new window.google.maps.InfoWindow())

      if (constants.IS_CHECKOUT() || constants.IS_PRODUCT || mailName === 'chooseStore') {
        window.google.maps.event.addListener(state.infoModal, 'domready', () => {
          const btn = document.querySelector('.map-info-modal__btn')
          const btnBuy = document.getElementById('reserve-buy-btn')
          const btnReserve = document.getElementById('reserve-btn')
          const btnPreOrder = document.getElementById('pre-order-btn')
          const btnWaitList = document.querySelector('.reserve-info__btn--wait-list')

          if (btnBuy) {
            btnBuy.addEventListener('click', function () {
              dispatch('ADD_PRODUCT_TO_CART', {
                productId: +rootState.productInfo.productInfo.productId,
                storeId: +this.dataset.id
              }).then(
                response => {
                  modal.hide('map-modal')
                  modal.show(rootGetters.cartModalName)
                  dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', true)

                  // window.gtag('event', 'add_to_cart', {
                  //   'ecomm_pagetype': window.ecomm_pagetype || 'other',
                  //   'ecomm_prodid': rootState.productInfo.productInfo.code,
                  //   'ecomm_totalvalue': rootState.productInfo.productInfo.price
                  // })

                  GoogleTagManagerService.addToCartEvent({
                    analyticsData: rootState.productInfo.productInfo.analyticsData,
                    params: {
                      'event': 'gtm-ee-event-add-to-cart',
                      'gtm-ee-event-action': 'Adding a Product to a Shopping Cart'
                    }
                  })

                  window.fbq('track', 'AddToCart', {
                    content_name: rootState.productInfo.productInfo.titleAnalytics,
                    content_ids: [rootState.productInfo.productInfo.code],
                    content_type: 'product',
                    value: rootState.productInfo.productInfo.price,
                    currency: window.config?.currency?.currency_code
                  })
                },
                () => {
                  modal.show('warning-modal', {
                    text: rootGetters.translations('product_ends_warning_text'),
                    title: rootGetters.translations('product_ends_warning_title')
                  })
                }
              )
            })
          }

          if (btnReserve) {
            btnReserve.addEventListener('click', function () {
              const { quantity, id, link, title, map, status } = this.dataset
              modal.hide('map-modal')
              modal.show('quick-order-modal', {
                quantity: +quantity,
                storeId: +id,
                link: link,
                title: title,
                staticMapLink: map,
                status: +status,
                type: 'reserve'
              })
            })
          }

          if (btnPreOrder) {
            btnPreOrder.addEventListener('click', function () {
              const { quantity, id, link, title, map, status } = this.dataset
              modal.hide('map-modal')
              modal.show('quick-order-modal', {
                quantity: +quantity,
                storeId: +id,
                link: link,
                title: title,
                staticMapLink: map,
                status: +status,
                type: 'pre-order'
              })
            })
          }

          if (btnWaitList) {
            btnWaitList.addEventListener('click', function changeWaitListFlag (e, target = null) {
              if (rootState.user && rootState.user.auth) {
                const trigger = target || this

                trigger.setAttribute('disabled', 'true')
                const { id } = trigger.dataset

                const postData = {
                  product_id: rootState.productInfo.productInfo.productId,
                  remove: +rootState.cabinet.waitlist.waitListStatusInShops[id],
                  store_id: id
                }

                dispatch('waitlist/CHANGE_WAIT_LIST_STATUS', { postData: postData }, { root: true }).then(() => {
                  trigger.innerText = rootState.cabinet.waitlist.waitListStatusInShops[id]
                    ? rootGetters.translations('already_in_wait_list')
                    : rootGetters.translations('add_to_wait_list')
                  trigger.removeAttribute('disabled')
                })
              } else {
                window.addEventListener('waitListTrigger', e => {
                  changeWaitListFlag(e, this)
                })

                modal.show('auth-modal', {
                  title: rootGetters.translations('wait_list_auth_message'),
                  isAjaxAuth: true,
                  referrer: 'wait-list'
                })
              }
            })
          }

          if (btn) {
            btn.addEventListener('click', () => {
              if (state.preselectedSpot) {
                if (state.preselectedSpot.is_our_shop) {
                  const deliverySpot = { ...state.preselectedSpot, title: state.preselectedSpot.description }
                  const value = rootState.contactsForm.deliveryTypes.find(el => {
                    return el.methodId === 1
                  })

                  dispatch('FETCH_DELIVERY_INFO', {
                    cityId: null,
                    methodId: 1
                  }).then(() => {
                    dispatch('SET_LOADING_COMPONENT', { deliveryTypes: false })
                    dispatch('SET_FORM_DATA', {
                      deliveryType: value,
                      deliveryInfo: { deliverySpot },
                      paymentType: null
                    })

                    setTimeout(() => {
                      const input = document.querySelector('.delivery-map-wrapper input.vs__search')
                      input.classList.add(`delivery-map-input--attention`)
                    }, 100)
                  })

                  dispatch('SET_SELECTED_SPOT_ACTION', deliverySpot)
                  dispatch('FETCH_PAYMENT_TYPE', {
                    storeUid: deliverySpot.uid,
                    cityId: null,
                    methodId: rootState.checkout.formData.deliveryType.methodId
                  })
                } else {
                  const deliverySpot = { ...state.preselectedSpot, title: state.preselectedSpot.description }
                  dispatch('SET_SELECTED_SPOT_ACTION', deliverySpot)
                  dispatch('FETCH_PAYMENT_TYPE', {
                    storeUid: deliverySpot.uid,
                    cityId: null,
                    methodId: rootState.checkout.formData.deliveryType.methodId
                  })
                  commit('REDUCE_FORM_DATA', { deliveryInfo: { deliverySpot } })
                }
              }
              modal.hide('map-modal')
            })
          }
        })
      }
      const bounds = new window.google.maps.LatLngBounds()

      spotsInfo.forEach(el => {
        if (!el) return

        const { latitude, longitude } = (constants.IS_CHECKOUT() || constants.IS_CHECKOUT_SUCCESS()) ? coordinatesProcessing(el) : el
        if (!latitude || !longitude) return
        const marker = new window.google.maps.Marker({
          position: {
            lat: latitude,
            lng: longitude
          },
          map: state.map,
          title: el.description,
          icon: markerIcon(el.type)
        })
        marker.services = el.services
        marker.type = el.type
        marker.isActive = false

        marker.addListener('click', () => {
          // Открывает инфомодал и записывает инфу по отделу в свойство preSelectedSpot для отрисовки инфы в инфомодале
          dispatch('OPEN_INFO_WINDOW', { marker, spot: el, mailName, modal })
          commit('SET_PRESELECTED_SPOT', el)
          marker.isActive = true
        })
        bounds.extend(new window.google.maps.LatLng({ lat: latitude, lng: longitude }))
        markers.push(marker)
      })

      if (ourSpotsInfo) {
        ourSpotsInfo.forEach(el => {
          if (!el) return

          el.is_our_shop = true

          const { latitude, longitude } = constants.IS_CHECKOUT() ? coordinatesProcessing(el, true) : el
          if (!latitude || !longitude) return
          const marker = new window.google.maps.Marker({
            position: {
              lat: latitude,
              lng: longitude
            },
            map: state.map,
            title: el.description,
            icon: markerIcon('our_shop')
          })
          marker.services = el.services
          marker.type = 'our_shop'
          marker.isActive = false

          marker.addListener('click', () => {
            // Открывает инфомодал и записывает инфу по отделу в свойство preSelectedSpot для отрисовки инфы в инфомодале
            dispatch('OPEN_INFO_WINDOW', { marker, spot: el, ourMailName, modal })
            commit('SET_PRESELECTED_SPOT', el)
            marker.isActive = true
          })
          bounds.extend(new window.google.maps.LatLng({ lat: latitude, lng: longitude }))
          markers.push(marker)
        })
      }

      commit('SET_BOUNDS', bounds)
      commit('SET_MARKERS', markers)

      if (
        (constants.IS_CHECKOUT() &&
          !rootState.geoLocation.isCityFromGeoSelected &&
          (!rootState.checkout.formData.deliveryInfo ||
            (rootState.checkout.formData.deliveryInfo && !rootState.checkout.formData.deliveryInfo.deliverySpot))) ||
        constants.IS_PRODUCT || mailName === 'chooseStore'
      ) {
        state.map.fitBounds(state.bounds)
      }

      window.google.maps.event.addListener(state.infoModal, 'closeclick', function () {
        state.markers.forEach(el => {
          el.isActive = false
          if (el.shopMarkerDisabled !== true) {
            el.setIcon(markerIcon(el.type))
          }
        })
      })
    },
    HANDLE_ADDRESS_SEARCH_DELIVERY ({ state, rootGetters, commit, dispatch }, data) {
      try {
        let result = {}
        if (data.isAddressFullSearch) {
          const place = data.autocomplete.getPlace()
          const selectedPlaceName = place.formatted_address || place.name || ''
          const citySuggest = place.address_components.find(el => el.types.find(el2 => el2 === 'locality'))
          const zipSuggest = place.address_components.find(el => el.types.find(el2 => el2 === 'postal_code'))
          const streetSuggest = place.address_components.find(el => el.types.find(el2 => el2 === 'route'))
          result = {
            place: selectedPlaceName,
            citySuggest: citySuggest && citySuggest.long_name ? citySuggest.long_name : '',
            zipSuggest: zipSuggest && zipSuggest.long_name ? zipSuggest.long_name : '',
            streetSuggest: streetSuggest && streetSuggest.long_name ? streetSuggest.long_name : ''
          }
        } else {
          const place = data.getPlace()
          const postCodeObj = place.address_components.find(el => el.types.find(el2 => el2 === 'postal_code'))
          const citySuggest = place.address_components.find(el => el.types.find(el2 => el2 === 'locality'))
          const selectedPlaceName = place.address_components[0].long_name
          result = {
            place: selectedPlaceName,
            citySuggest: citySuggest.long_name
          }
          if (postCodeObj) {
            result.postCode = postCodeObj.long_name
          }
        }
        return result
      } catch (e) {
        throw new Error(e)
      }
    },
    HANDLE_ADDRESS_SEARCH ({ state, rootGetters, commit, dispatch }, autocomplete) {
      try {
        const place = autocomplete.getPlace()
        const selectedCityName = autocomplete.getPlace().name.toLowerCase()
        if (autocomplete.getPlace().geometry) {
          state.map.setCenter(autocomplete.getPlace().geometry.location)
          state.map.setZoom(state.citiesZoom[selectedCityName] || 15)
        }

        if (!place.geometry) {
          return
        }
        if (state.addressMarker) {
          state.addressMarker.setMap(null)
        }
        commit(
          'SET_ADDRESS_MARKER',
          new window.google.maps.Marker({
            position: autocomplete.getPlace().geometry.location,
            map: state.map
          })
        )

        const textForInfowindow = rootGetters.translation('map.info_window.text')
        const addressInput = document.querySelector('#addressSearch')
        const infowindow = new window.google.maps.InfoWindow({
          content: `<p>${textForInfowindow + addressInput.value}</p>`
        })

        state.addressMarker.addListener(`click`, () => {
          infowindow.open(state.map, state.addressMarker)
        })

        const placeLatLng = place.geometry.location
        const closestMarker = dispatch('FIND_NEAREST_SPOT', placeLatLng)

        state.map.fitBounds(closestMarker.bounds)
      } catch (e) {}
    },
    HANDLE_SELECT_CITY_WITHOUT_SHOPS ({ commit, state, dispatch }, location) {
      const geo = new window.google.maps.LatLng({
        lat: parseFloat(location.latitude),
        lng: parseFloat(location.longitude)
      })

      if (state.addressMarker) {
        state.addressMarker.setMap(null)
      }

      commit(
        'SET_ADDRESS_MARKER',
        new window.google.maps.Marker({
          position: geo,
          map: state.map
        })
      )

      dispatch('FIND_NEAREST_SPOT', geo)
    },
    FIND_NEAREST_SPOT ({ commit, state, rootState }, coords) {
      // const { selectedUserLocation } = rootState.geoLocation
      // const geo2 = new window.google.maps.LatLng({
      //   lat: parseFloat(selectedUserLocation.latitude),
      //   lng: parseFloat(selectedUserLocation.longitude)
      // })
      // let distance = window.google.maps.geometry.spherical.computeDistanceBetween(coords, geo2)
      //
      // let bounds = new window.google.maps.LatLngBounds()
      // bounds.extend(coords)
      // let minDist = 1000000000000
      // let nearestPoint = null
      //
      // for (let i = 0; i < state.markers.length; i++) {
      //   state.markers[i].setMap(state.map)
      //   const markerLatLng = state.markers[i].getPosition()
      //   distance = window.google.maps.geometry.spherical.computeDistanceBetween(coords, markerLatLng)
      //   if (distance < minDist && state.markers[i].type !== 'our_shop') {
      //     minDist = distance
      //     nearestPoint = state.markers[i].getPosition()
      //   }
      // }
      // state.map.setCenter(coords)
      // if (nearestPoint) {
      //   bounds.extend(nearestPoint)
      //   state.map.fitBounds(bounds)
      // }
    },
    INIT_AUTOCOMPLETE ({ commit }, autocomplete) {
      commit('SET_AUTOCOMPLETE', autocomplete)
    },
    FIND_ME ({ dispatch, state, rootState, commit }) {
      const { exactUserLocation } = rootState.geoLocation

      const geocoder = new window.google.maps.Geocoder()
      const addressSearch = document.querySelector('#addressSearch')
      processBrowserNavigator(
        ({ coords }) => {
          const latlng = new window.google.maps.LatLng(coords.latitude, coords.longitude)

          geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status === window.google.maps.GeocoderStatus.OK) {
              if (results[1]) {
                if (addressSearch) addressSearch.value = results[1].formatted_address

                dispatch('SET_EXACT_USER_GEO_FROM_GPS', { coords }).then(response => {
                  if (response.city_list && response.city_list.length) {
                    dispatch('SET_MAP_POSITION_BY_GEO', true)
                  } else {
                    if (state.userMarker) {
                      state.userMarker.setPosition(latlng)
                    } else {
                      commit(
                        'SET_USER_MARKER',
                        new window.google.maps.Marker({
                          position: latlng,
                          map: state.map,
                          icon: {
                            url: `/img/svgo/map-pin-user-location.svg`,
                            size: new window.google.maps.Size(50, 50),
                            origin: new window.google.maps.Point(0, 0),
                            anchor: new window.google.maps.Point(25, 25)
                          }
                        })
                      )
                    }
                    state.map.setCenter(latlng)
                    state.map.setZoom(15)
                  }
                })
                startAnimation()
              }
            }
          })
        },
        () => {
          if (addressSearch) {
            addressSearch.value = exactUserLocation.name
          }

          const latlng = new window.google.maps.LatLng(+exactUserLocation.latitude, +exactUserLocation.longitude)
          state.map.setCenter(latlng)
          const selectedCityName = exactUserLocation.name.toLowerCase()
          state.map.setZoom(state.citiesZoom[selectedCityName] || 15)
          startAnimation()
        },
        true
      )

      function startAnimation () {
        if (addressSearch) addressSearch.classList.add(`address-search--attention`)

        setTimeout(() => {
          addressSearch.classList.remove(`address-search--attention`)
        }, 1000)
      }
    },
    OPEN_INFO_WINDOW ({ state, rootGetters, rootState }, { marker, spot, mailName, ourMailName, modal }) {
      if (spot.hasOwnProperty('isInWaitList')) {
        spot.isInWaitList = rootState.cabinet.waitlist.waitListStatusInShops[spot.storeId]
      }

      const isAdmin = rootState.user.userType === constants.USER_TYPE.MANAGER

      // Открывает инфомодал
      state.map.panTo(marker.getPosition())
      state.map.setZoom(16)
      // TO_DO hotfix для прода, виправити потім
      if (constants.IS_SHOPS) {
        if (
          (detectMobileDevices.any() && !window.matchMedia(`(min-width: 426px)`).matches) ||
          detectMobileDevices.isTouch()
        ) {
          modal.show('shop-card-modal', {
            shopData: spot
          })
        } else {
          state.infoModal.close()
          state.infoModal.setContent(
            createMapInfoModal(spot, mailName, ourMailName, rootGetters.translations, rootState.productInfo.productInfo)
          )
          state.infoModal.open(state.map, marker)
        }
      } else {
        state.infoModal.close()
        state.infoModal.setContent(
          createMapInfoModal(
            spot,
            mailName,
            ourMailName,
            rootGetters.translations,
            rootState.productInfo.productInfo,
            isAdmin
          )
        )
        state.infoModal.open(state.map, marker)
      }
    },
    SET_SELECTED_SPOT_ACTION ({ commit, rootState, dispatch }, spot) {
      commit('SET_SELECTED_SPOT', spot)

      if (
        ((rootState.checkout.formData.deliveryType && rootState.checkout.formData.deliveryType.methodId === 1) ||
          (rootState.checkout.formData.deliveryType &&
            rootState.checkout.formData.deliveryType.methodId === 1 &&
            rootState.deliveryForm.deliveryInfoOurShops)) &&
        constants.IS_CHECKOUT()
      ) {
        dispatch('GET_FULL_CART', {
          notUpdateCheckout: true,
          storeUid: spot.uid,
          deliveryType: rootState.checkout.formData.deliveryType.methodId
        })
      }
    },
    SET_USER_MARKER_ACTION ({ commit }, marker) {
      commit('SET_USER_MARKER', marker)
    },
    SET_PRESELECTED_SPOT_ACTION ({ commit }, spot) {
      commit('SET_PRESELECTED_SPOT', spot)
    }
  }
}
